<template>
  <v-container>
    <v-row>
      <v-col>
        <p class="text-h3">Device Setup</p>
        <p>
          We will assume you have Arduino IDE installed on your machine and some
          basic knowledge of flashing firmware onto an ESP using the IDE.
        </p>
        <p class="text-h5">
          Download the Firmware for your specific device.
        </p>
        <p>
          <v-chip label color="primary" class="mr-4">ESP8266</v-chip>
          <v-chip label color="primary">ESP32</v-chip>
        </p>

        <p class="text-h5">Enter your Firebase Crendentials</p>
        <p>
          ~ Using the Host and Secret you got from Firebase, enter these
          credentials into the following lines:
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
